import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 로그 수집기 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getLogCollector() {
    return axios.get(`${baseUrl}/settings/lms-applog/get-log-collector.do`);
  },
  /**
   * 어플리케이션 설정 팝업에서 패턴 목록 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getParsingPattern() {
    return axios.get(`${baseUrl}/settings/lms-applog/get-parsing-pattern.do`);
  },
  /**
   * 어플리케이션 로그 목록 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getApplogList(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/get-applog-list.do`, params);
  },
  /**
   * 장치 선택 시 수집 서버 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getServerCollector(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/get-server-collector.do`, params);
  },
  /**
   * 연동 장비 호출
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getLinkObjList(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/get-link-obj-list.do`, params);
  },
  /**
   * 추가하려는 어플리케이션 로그의 아이디가 이미 존재하는지 확인
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkApplogId(params) {
    return axios.get(`${baseUrl}/settings/lms-applog/check-applog-id.do`, params);
  },
  /**
   * 어플리케이션 로그 추가
   * @author leesy918
   * @param  {[type]} params [description]
   */
  addLmsApplog(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/add-lms-applog.do`, params);
  },
  /**
   * 어플리케이션 로그 수집 서버 추가
   * @author leesy918
   * @param  {[type]} params [description]
   */
  addServerCollector(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/add-server-collector.do`, params);
  },
  /**
   * 어플리케이션 로그 그룹 저장
   * @author leesy918
   * @param  {[type]} queryString [description]
   * @param  {[type]} params      [description]
   */
  addApploggroup(queryString, params) {
    return axios.post(`${baseUrl}/settings/lms-applog/add-applog-group.do?${queryString}`, params);
  },
  /**
   * 어플리케이션 로그 수정
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateLmsApplog(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/update-lms-applog.do`, params);
  },
  /**
   * 비밀번호 업데이트
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateApplogPassword(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/update-applog-password.do`, params);
  },
  /**
   * 어플리케이션 로그 비밀번호 확인
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkApplogPassword(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/check-applog-password.do`, params);
  },
  /**
   * 어플리케이션 로그 삭제
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteLmsApplog(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/delete-lms-applog.do`, params);
  },

  /**
   * 어플리케이션 로그 수집 서버 업데이트
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateServerCollector(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/update-server-collector.do`, params);
  },

  /**
   * 필터 추가
   * @author leesy918
   * @param  {[type]} params [description]
   */
  addApplogFilter(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/add-applog-filter.do`, params);
  },
  /**
   * 필터 조건 수정
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateApplogFilter(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/update-applog-filter.do`, params);
  },

  /**
   * 필터 그룹 저장
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  saveApplogFilterGroup(queryString, params) {
    return axios.post(`${baseUrl}/settings/lms-applog/save-applog-filter-group.do?${queryString}`, params);
  },
  /**
   * 필터링 설정 탭에서 사용할 정보를 가져온다
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getApplogFilterList(params) {
    return axios.get(`${baseUrl}/settings/lms-applog/get-applog-filter.do`, { params });
  },
  /**
   * 보유한 설정 로그의 이름을 가져온다.
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getApplogName(params) {
    return axios.get(`${baseUrl}/settings/lms-applog/get-applog-name.do`, { params });
  },
  /**
   * 필터 삭제
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteApplogFilter(params) {
    return axios.post(`${baseUrl}/settings/lms-applog/delete-applog-filter.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/lms-applog-setting.js